module.exports = __webpack_public_path__ + "img/04.597b6f16.jpg";